import script from "./TxtInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TxtInput.vue?vue&type=script&setup=true&lang=js"

import "./TxtInput.vue?vue&type=style&index=0&id=81da7482&lang=scss"

const __exports__ = script;

export default __exports__